import classnames from 'classnames';
import { CKButton } from 'clearkit';
import moment from 'moment';

type ActiveIntegrationsTimeRangeFiltersProps = {
  queryStartDate: moment.Moment;
  setQueryStartDate: (arg: moment.Moment) => void;
};
function ActiveIntegrationsTimeRangeFilters({
  queryStartDate,
  setQueryStartDate,
}: ActiveIntegrationsTimeRangeFiltersProps) {
  const timeRanges = [
    { label: 'Last 7 Days', startDate: dateRangeStartDate(-7, 'day') },
    { label: 'Last 14 Days', startDate: dateRangeStartDate(-14, 'day') },
    { label: 'Last 30 Days', startDate: dateRangeStartDate(-30, 'day') },
    { label: 'Last 3 Months', startDate: dateRangeStartDate(-3, 'month') },
    { label: 'Last Year', startDate: dateRangeStartDate(-1, 'year') },
    { label: 'All Time', startDate: dateRangeStartDate(-2, 'year') },
  ];

  return (
    <div className="flex items-center py-2 text-base font-medium text-gray-600 min-h-[2.5rem] gap-x-4">
      <div>Show data for:</div>
      <div className="flex gap-4">
        {timeRanges.map((x) => {
          const currentPeriod = moment(x.startDate).isSame(
            queryStartDate,
            'day',
          );
          return (
            <div
              className={classnames('flex', {
                'border-l border-gray-200 pl-4': x.label == 'All Time',
              })}
              key={x.label}
            >
              <CKButton
                className="!px-2 !py-0.5 !h-auto !bg-none"
                onClick={() => setQueryStartDate(x.startDate)}
                size="small"
                variant={currentPeriod ? 'bold' : 'tertiary'}
                variantColor={currentPeriod ? 'blue' : 'default'}
              >
                {x.label}
              </CKButton>
            </div>
          );
        })}
      </div>
    </div>
  );
}
function dateRangeStartDate(
  amountToAdd: number,
  unit: moment.DurationInputArg2,
) {
  return moment().add(amountToAdd, unit);
}

export default ActiveIntegrationsTimeRangeFilters;
